export default __webpack_public_path__ + "static/media/CNo.15-4.5f51d876.jpg";